import React from 'react';
import HighlightFeature, {
  ACTION_CLICK_TABLE_HEADER,
  ACTION_DISABLE,
  ACTION_DRILLDOWN,
  ACTION_SAVE_QUERY,
  CREATE_CHART,
  CREATE_TREND_CHART,
  SUMMARIZE,
  TOP,
} from '@/components/HighlightFeature';

export const SingleValueOnboarding = () => (
  <HighlightFeature
    position={TOP}
    text={
      <span>
        Try adding a <b>trend label (e.g. +4%)</b> to a single value chart
      </span>
    }
    style={{ minWidth: '410px' }}
    requiredActions={[
      SUMMARIZE,
      ACTION_DRILLDOWN,
      ACTION_DISABLE,
      CREATE_CHART,
      ACTION_CLICK_TABLE_HEADER,
      ACTION_SAVE_QUERY,
    ]}
    targetAction={CREATE_TREND_CHART}
    hideButton
    delay={3500}
    hideWhenModalsOpen
  />
);
